module.exports = __webpack_public_path__ + "images/1e0c9cd3a95b0c0e4675b3308a2eb15abc261d6fa5928472e3240e925fc7ba57.svg";